import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { IAuthAggregate } from '../auth.aggregate';
import { FusionAuthAggregate } from './fusion-auth.aggregate';
import { CookieAuthAggregate } from './cookie-auth.aggregate';
import { IRuntimeConfiguration } from '../../../infrastructure/runtime-configuration';

/**
 * provide a refernce to the single instance of IAuthAggregate of chosen implementation
 * responsible for creation of this instance
 */
class AuthAggregateProvider {
    @mobx.observable
    private instance: IAuthAggregate;

    private constructAuthAggregate(): IAuthAggregate {
        const runtimeConfiguration = IoC.Container.get(IRuntimeConfiguration);
        return runtimeConfiguration.useCookieAuth()
            ? new CookieAuthAggregate()
            : new FusionAuthAggregate();
    }

    @mobx.action
    public async init(): Promise<void> {
        if (!this.instance) {
            const authAggregate = this.constructAuthAggregate();
            await authAggregate.initialize();
            mobx.runInAction(() => {
                this.instance = authAggregate;
            });
        }
    }

    /**
     * always returns single instance, created by fist call to 'init' method
     */
    public get() {
        return this.instance;
    }
}

export { AuthAggregateProvider };
